<template>
    <nav class="navbar navbar-expand-lg navbar" id="navbar-header">
        <div class="container">
            <router-link class="navbar-brand" to="/">{{title}}</router-link>

            <ul class="navbar-nav">
                <li class="nav-item">
                    <a v-if="$root.isGuest" class="nav-link" href="javascript:;" @click="goToLogin">Sign In</a>
                    <a v-else class="nav-link" href="javascript:;" @click="$root.logout">Logout ({{username}})</a>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name: "NavHeader",
    methods: {
        goToLogin() {
            this.$router.push({
                path: '/login',
                query: {
                    force: 1
                }
            })
        }
    },
    computed: {
        username() {
            return this.$root.authInfo.username
        },
        title() {
            return _appConfig.appTitle
        }
    }
}
</script>

<style scoped>
    #navbar-header {
        background: #f1f1f1;
        border-bottom: solid 1px #e7e7e7;
        min-height: 50px;
    }

    .navbar {
        padding: 0;
    }

    .navbar .navbar-brand {
        font-size: 16px;
        color: #555;
    }

    .navbar .navbar-nav .nav-item .nav-link {
        font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
        font-size: 14px;
        line-height: 20px;
        color: #555;
        background-color: #e7e7e7;
        padding: 15px;
    }

    .navbar .navbar-nav .nav-item .nav-link:hover {
        background: #e5e5e5;
    }
</style>
